import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface validatePasscodeState {
  isValidatePasscodeLoading: boolean;
  isValidatePasscodeError: any | null;
  validationPasscode: any | null;
}

const initialState: validatePasscodeState = {
  isValidatePasscodeLoading: false,
  isValidatePasscodeError: null,
  validationPasscode: null,
};

const validatePasscodeSlice = createSlice({
  name: 'validatePasscode',
  initialState,
  reducers: {
    // fetch generate code for device status
    validatePasscodeRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        deviceId: string;
        oneTimePassCode: string;
        username: string;
      }>
    ) {
      state.isValidatePasscodeLoading = true;
      state.isValidatePasscodeError = null;
    },
    validatePasscodeSuccess(state, action: PayloadAction<any>) {
      state.isValidatePasscodeLoading = false;
      state.validationPasscode = action.payload;
      state.isValidatePasscodeError = null;
    },
    validatePasscodeFailure(state, action: PayloadAction<any>) {
      state.isValidatePasscodeLoading = false;
      state.isValidatePasscodeError = action.payload;
    },
    resetPasscodeState(state, action: PayloadAction<any>) {
      state.isValidatePasscodeLoading = false;
      state.isValidatePasscodeError = null;
    },
    resetValidatePasscodeSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  validatePasscodeRequest,
  validatePasscodeSuccess,
  validatePasscodeFailure,
  resetPasscodeState,
  resetValidatePasscodeSlice,
} = validatePasscodeSlice.actions;

export default validatePasscodeSlice.reducer;
